export const colors = {
    primaryGreen: "#007f3b",
    secondaryGray: "#f0f2f5",
    darkGrayBackground: "#333333",
    actionBlue: "#007bff",
    actionBlueHover: "#0056b3",
    textDark: "#1c1e21",
  };